module.exports = __webpack_public_path__ + "static/videos/explanation-2.c12e351.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/explanation-2.mp4
// module id = aD5l
// module chunks = 1